import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from "vue";
import VolumesOverlay from "#src/components/VolumesOverlay.vue";
import DropdownList from "#src/components/DropdownList.vue";
import { loginSession, useLoginStore, useVolumesStore } from "#src/store.js";
import logoImage from "#src/CaveLogo-clear.png";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExtensionBar',
  setup(__props, { expose: __expose }) {
  __expose();

const login = useLoginStore();
window.addEventListener("middleauthlogin", () => {
  login.update();
});
login.update();

const validLogins = computed(() =>
  login.sessions.filter((x) => x.status === undefined)
);
const invalidLogins = computed(() =>
  login.sessions.filter((x) => x.status !== undefined)
);

const { volumes } = useVolumesStore();

onMounted(() => {
  (
    document.querySelector(".ng-extend-logo > a > img")! as HTMLImageElement
  ).src = logoImage;
});

const showModal = ref(false);

function logout(session: loginSession) {
  login.logout(session);
}

const __returned__ = { login, validLogins, invalidLogins, volumes, showModal, logout, VolumesOverlay, DropdownList }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})